import groupBy from 'lodash/groupBy';
import partition from 'lodash/partition';
import sortBy from 'lodash/sortBy';

import { UnwrapArray } from '@sbv-clients/util-misc';

import { FacilityMenuByIdResponseType } from '../services/admin';

export const transformToMenuAndSubMenu = (
  data: FacilityMenuByIdResponseType[]
) => {
  const sortedData = sortBy(data, 'order');
  const [parentMenus, childMenus] = partition(
    sortedData,
    (item) => !item.parentId
  );
  const childMenuByParentId = groupBy(childMenus, 'parentId');
  return parentMenus.map((item) => {
    return {
      ...item,
      children: childMenuByParentId[item.id as string],
    };
  });
};

export type ParentMenuWithSubMenuItemsType = UnwrapArray<
  ReturnType<typeof transformToMenuAndSubMenu>
>;
